
export default {
  name: 'HSelect',

  props: {
    label: {
      type: [String, Boolean],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    inlineEditor: {
      type: Boolean,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
      validator: (value) => typeof value === 'object' || 'string',
      required: true,
    },
    value: {
      type: [String, Object, Array, Number],
      default: '',
    },
    multiple: {
      type: Boolean,
    },
    returnObject: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'secondary',
    },
    backgroundColor: {
      type: String,
      default: 'grey lighten-2',
    },
    prependInnerIcon: {
      type: String,
      default: '',
    },
    menuProps: {
      type: Object,
      default: () => ({ bottom: true, offsetY: true }),
    },
    filled: {
      type: Boolean,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    dense: {
      type: Boolean,
    },
    hasError: {
      type: Boolean,
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
    loading: {
      type: [Boolean, String],
      default: false,
    },
    disabled: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    autocomplete: {
      type: [String, Boolean],
      default: 'nope',
    },
    autofocus: {
      type: Boolean,
    },
    validateOnBlur: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    required: {
      type: Boolean,
    },
    attach: {
      type: Boolean,
    },
    eager: {
      type: Boolean,
    },
    customSelection: {
      type: Boolean,
    },
    selectAllOptions: {
      type: Boolean,
    },
  },

  data() {
    return {
      dynamicWidth: 'auto',
    }
  },

  computed: {
    allItems() {
      return this.value.length === this.items.length;
    },

    someItems() {
      return this.value.length > 0 && !this.allItems;
    },

    icon() {
      if (this.allItems) {
        /*
         * TODO: This icon used to come from material UI
         * we don't current'y have a matching icon in the
         * Hypofriend Icon list. If we are to use this feature
         * please ensure we have a matching icon and replace 'close-box'
         * with the new version
         */
        return 'close-box';
      }

      if (this.someItems) {
        return 'checkbox_indeterminate';
      }

      return 'checkbox_off';
    },
  },

  methods: {
    bubbleChangeEvent(e = '') {
      if (this.inlineEditor) {
        this.calculateCustomWidth(e);
      }
      this.$emit('change', e);
    },

    bubbleInputEvent(e = '') {
      this.$emit('input', e);
    },

    toggle() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.$emit('input', []);
          return;
        }

        if (this.returnObject) {
          this.$emit('input', this.items.slice());
          return;
        }

        this.$emit(
          'input',
          this.items.map((item) => item.value),
        );
      });
    },

    calculateCustomWidth(value) {
      const CHAR_WIDTH = 10;
      const BASE_PADDING = 32;
      const EXTRA_PADDING_THRESHOLD = 0;
      const EXTRA_PADDING = 26;

      const text = value == null ? '' : String(value);
      let visibleLength = text.length + (this.suffix ? 1 : 0);
      
      const padding =
        visibleLength > EXTRA_PADDING_THRESHOLD
          ? BASE_PADDING + EXTRA_PADDING
          : BASE_PADDING;

        this.dynamicWidth = `${(visibleLength * CHAR_WIDTH) + padding}px`;
    }
  },

  watch: {
    value: {
      handler(newValue) {
        if (this.inlineEditor) {
          this.calculateCustomWidth(newValue);
        }
      },
      immediate: true,
    }
  }
};
